let base_url = 'https://api.yingtiyu.com/api'

export default base_url